/**
 * Бренд кабинета как параметр сборки. Кабинеты ottkit.io и adult-инстанса
 * собираются из одного кода, отличаются знак, фавиконка и заголовок вкладки.
 * Значение приходит из VITE_BRAND на сборке, дефолт ottkit: без переменной
 * всё остаётся как было.
 *
 * Модуль намеренно чистый, без import.meta: его же таблицу читает
 * vite.config.ts, чтобы подставить title и favicon в index.html.
 */

export type BrandName = "ottkit" | "xxxkit";

export interface CabinetBrand {
  name: BrandName;
  /** Заголовок вкладки кабинета */
  title: string;
  /** Файл фавиконки в cabinet/public */
  favicon: string;
  /** Файл знака в cabinet/public: шапка кабинета и экран входа */
  miniLogo: string;
  /** Цвета бренда: из них собирается палитра MUI (shared/utils/createTheme) */
  colors: CabinetBrandColors;
}

export interface CabinetBrandColors {
  /** Основной цвет интерфейса */
  primary: string;
  /** Текст на основном цвете */
  contrastText: string;
  /** Дополнительный цвет: светлая точка градиента знака */
  secondary: string;
}

const BRANDS: Record<BrandName, CabinetBrand> = {
  ottkit: {
    name: "ottkit",
    title: "ottkit",
    // Имена без суффикса бренда остаются за ottkit: на них уже стоят
    // ссылки в index.html и в закладках.
    favicon: "favicon.png",
    miniLogo: "miniLogo.png",
    // Цвета ottkit прежние: оранжевый интерфейса не меняется от нового знака.
    colors: {
      primary: "#FF5500",
      contrastText: "#ffffff",
      secondary: "#FC8311",
    },
  },
  xxxkit: {
    name: "xxxkit",
    title: "xxxkit",
    favicon: "favicon-xxxkit.png",
    miniLogo: "miniLogo-xxxkit.png",
    // Основной цвет это середина градиента знака xxxkit, дополнительный —
    // его светлая точка. Те же значения, что у витрины.
    colors: {
      primary: "#D4148E",
      contrastText: "#ffffff",
      secondary: "#FF2E9A",
    },
  },
};

export const DEFAULT_BRAND: BrandName = "ottkit";

/** Бренд по имени. Незнакомое значение не роняет сборку, а даёт ottkit. */
export function resolveBrand(name?: string | null): CabinetBrand {
  if (name && name in BRANDS) {
    return BRANDS[name as BrandName];
  }
  return BRANDS[DEFAULT_BRAND];
}
